"use client";
import { useNavigate } from "react-router";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <main className="flex-grow flex flex-col items-center justify-center text-center px-6 py-20 space-y-8">
        <div>
          <h1>404</h1>
          <p className="mt-4 text-gray-600 max-w-md mx-auto">
            Oops! The page you’re looking for doesn’t exist or may have been moved.
          </p>
        </div>

        <div className="m-auto w-full h-80 flex items-center justify-center">
          <img
            src="/404.svg"
            alt="Page not found"
            className="object-contain max-w-full max-h-full"
          />
        </div>

        <button
          onClick={() => navigate(-1)} // 👈 Go back to previous page
          className="btn px-6 btn-primary py-3 cursor-pointer text-base"
        >
          Go Back
        </button>
      </main>
    </div>
  );
}
